export interface Region {
  id: string;
  nameAm: string;
  nameRu: string;
  nameEn: string;
  nameFa: string;
  cities: City[];
}

export interface City {
  id: string;
  nameAm: string;
  nameRu: string;
  nameEn: string;
  nameFa: string;
}

export const armeniaRegions: Region[] = [
  {
    id: 'yerevan',
    nameAm: 'Երևան',
    nameRu: 'Ереван',
    nameEn: 'Yerevan', nameFa: 'ایروان',
    cities: [
      { id: 'yere_ajapnyak', nameAm: 'Աջափնյակ', nameRu: 'Аджапняк', nameEn: 'Ajapnyak', nameFa: 'آجاپنیاک' },
      { id: 'yere_avan', nameAm: 'Ավան', nameRu: 'Аван', nameEn: 'Avan', nameFa: 'آوان' },
      { id: 'yere_arabkir', nameAm: 'Արաբկիր', nameRu: 'Арабкир', nameEn: 'Arabkir', nameFa: 'آرابکیر' },
      { id: 'yere_davtashen', nameAm: 'Դավթաշեն', nameRu: 'Давташен', nameEn: 'Davtashen', nameFa: 'داوتاشن' },
      { id: 'yere_erebuni', nameAm: 'Էրեբունի', nameRu: 'Эребуни', nameEn: 'Erebuni', nameFa: 'اربونی' },
      { id: 'yere_kentron', nameAm: 'Կենտրոն', nameRu: 'Кентрон', nameEn: 'Kentron', nameFa: 'کنترون' },
      { id: 'yere_malatia', nameAm: 'Մալաթիա-Սեբաստիա', nameRu: 'Малатия-Себастия', nameEn: 'Malatia-Sebastia', nameFa: 'مالاتیا-سباستیا' },
      { id: 'yere_nor_nork', nameAm: 'Նոր Նորք', nameRu: 'Нор Норк', nameEn: 'Nor Nork', nameFa: 'نور نورک' },
      { id: 'yere_nork_marash', nameAm: 'Նորք-Մարաշ', nameRu: 'Норк-Мараш', nameEn: 'Nork-Marash', nameFa: 'نورک-ماراش' },
      { id: 'yere_nubarashen', nameAm: 'Նուբարաշեն', nameRu: 'Нубарашен', nameEn: 'Nubarashen', nameFa: 'نوباراشن' },
      { id: 'yere_shengavit', nameAm: 'Շենգավիթ', nameRu: 'Шенгавит', nameEn: 'Shengavit', nameFa: 'شنگاویت' },
      { id: 'yere_kanaker', nameAm: 'Քանաքեռ-Զեյթուն', nameRu: 'Канакер-Зейтун', nameEn: 'Kanaker-Zeytun', nameFa: 'کاناکر-زیتون' }
    ]
  },
  {
    id: 'aragatsotn',
    nameAm: 'Արագածոտն',
    nameRu: 'Арагацотн',
    nameEn: 'Aragatsotn', nameFa: 'آراگاتسوتن',
    cities: [
      { id: 'arag_ashtarak', nameAm: 'Աշտարակ', nameRu: 'Аштарак', nameEn: 'Ashtarak', nameFa: 'آشتاراک' },
      { id: 'arag_aparan', nameAm: 'Ապարան', nameRu: 'Апаран', nameEn: 'Aparan', nameFa: 'آپاران' },
      { id: 'arag_talin', nameAm: 'Թալին', nameRu: 'Талин', nameEn: 'Talin', nameFa: 'تالین' }
    ]
  },
  {
    id: 'ararat',
    nameAm: 'Արարատ',
    nameRu: 'Арарат',
    nameEn: 'Ararat', nameFa: 'آرارات',
    cities: [
      { id: 'arar_artashat', nameAm: 'Արտաշատ', nameRu: 'Арташат', nameEn: 'Artashat', nameFa: 'آرتاشات' },
      { id: 'arar_ararat', nameAm: 'Արարատ', nameRu: 'Арарат', nameEn: 'Ararat', nameFa: 'آرارات' },
      { id: 'arar_masis', nameAm: 'Մասիս', nameRu: 'Масис', nameEn: 'Masis', nameFa: 'ماسیس' },
      { id: 'arar_vedi', nameAm: 'Վեդի', nameRu: 'Веди', nameEn: 'Vedi', nameFa: 'ودی' }
    ]
  },
  {
    id: 'armavir',
    nameAm: 'Արմավիր',
    nameRu: 'Армавир',
    nameEn: 'Armavir', nameFa: 'آرماویر',
    cities: [
      { id: 'arma_armavir', nameAm: 'Արմավիր', nameRu: 'Армавир', nameEn: 'Armavir', nameFa: 'آرماویر' },
      { id: 'arma_vagharshapat', nameAm: 'Վաղարշապատ', nameRu: 'Вагаршапат', nameEn: 'Vagharshapat', nameFa: 'واغارشاپات' },
      { id: 'arma_metsamor', nameAm: 'Մեծամոր', nameRu: 'Мецамор', nameEn: 'Metsamor', nameFa: 'متسامور' }
    ]
  },
  {
    id: 'gegharkunik',
    nameAm: 'Գեղարքունիք',
    nameRu: 'Гехаркуник',
    nameEn: 'Gegharkunik', nameFa: 'گغارکونیک',
    cities: [
      { id: 'gegh_gavar', nameAm: 'Գավառ', nameRu: 'Гавар', nameEn: 'Gavar', nameFa: 'گاوار' },
      { id: 'gegh_sevan', nameAm: 'Սևան', nameRu: 'Севан', nameEn: 'Sevan', nameFa: 'سوان' },
      { id: 'gegh_martuni', nameAm: 'Մարտունի', nameRu: 'Мартуни', nameEn: 'Martuni', nameFa: 'مارتونی' },
      { id: 'gegh_vardenis', nameAm: 'Վարդենիս', nameRu: 'Варденис', nameEn: 'Vardenis', nameFa: 'واردنیس' },
      { id: 'gegh_chambarak', nameAm: 'Ճամբարակ', nameRu: 'Чамбарак', nameEn: 'Chambarak', nameFa: 'چامباراک' }
    ]
  },
  {
    id: 'kotayk',
    nameAm: 'Կոտայք',
    nameRu: 'Котайк',
    nameEn: 'Kotayk', nameFa: 'کوتایک',
    cities: [
      { id: 'kota_hrazdan', nameAm: 'Հրազդան', nameRu: 'Раздан', nameEn: 'Hrazdan', nameFa: 'هرازدان' },
      { id: 'kota_abovyan', nameAm: 'Աբովյան', nameRu: 'Абовян', nameEn: 'Abovyan', nameFa: 'آبوویان' },
      { id: 'kota_charentsavan', nameAm: 'Չարենցավան', nameRu: 'Чаренцаван', nameEn: 'Charentsavan', nameFa: 'چارنتساوان' },
      { id: 'kota_nor_hachn', nameAm: 'Նոր Հաճն', nameRu: 'Нор Ачн', nameEn: 'Nor Hachn', nameFa: 'نور هاچن' },
      { id: 'kota_tsaghkadzor', nameAm: 'Ծաղկաձոր', nameRu: 'Цахкадзор', nameEn: 'Tsaghkadzor', nameFa: 'تساغکادزور' },
      { id: 'kota_yeghvard', nameAm: 'Եղվարդ', nameRu: 'Егвард', nameEn: 'Yeghvard', nameFa: 'یغوارد' }
    ]
  },
  {
    id: 'lori',
    nameAm: 'Լոռի',
    nameRu: 'Лори',
    nameEn: 'Lori', nameFa: 'لوری',
    cities: [
      { id: 'lori_vanadzor', nameAm: 'Վանաձոր', nameRu: 'Ванадзор', nameEn: 'Vanadzor', nameFa: 'وانادزور' },
      { id: 'lori_spitak', nameAm: 'Սպիտակ', nameRu: 'Спитак', nameEn: 'Spitak', nameFa: 'اسپیتاک' },
      { id: 'lori_stepanavan', nameAm: 'Ստեփանավան', nameRu: 'Степанаван', nameEn: 'Stepanavan', nameFa: 'استپانوان' },
      { id: 'lori_alaverdi', nameAm: 'Ալավերդի', nameRu: 'Алаверди', nameEn: 'Alaverdi', nameFa: 'آلاوردی' },
      { id: 'lori_tashir', nameAm: 'Տաշիր', nameRu: 'Ташир', nameEn: 'Tashir', nameFa: 'تاشیر' },
      { id: 'lori_akhtala', nameAm: 'Ախթալա', nameRu: 'Ахтала', nameEn: 'Akhtala', nameFa: 'آختالا' },
      { id: 'lori_tumanyan', nameAm: 'Թումանյան', nameRu: 'Туманян', nameEn: 'Tumanyan', nameFa: 'تومانیان' }
    ]
  },
  {
    id: 'shirak',
    nameAm: 'Շիրակ',
    nameRu: 'Ширак',
    nameEn: 'Shirak', nameFa: 'شیراک',
    cities: [
      { id: 'shir_gyumri', nameAm: 'Գյումրի', nameRu: 'Гюмри', nameEn: 'Gyumri', nameFa: 'گیومری' },
      { id: 'shir_artik', nameAm: 'Արթիկ', nameRu: 'Артик', nameEn: 'Artik', nameFa: 'آرتیک' },
      { id: 'shir_maralik', nameAm: 'Մարալիկ', nameRu: 'Маралик', nameEn: 'Maralik', nameFa: 'مارالیک' }
    ]
  },
  {
    id: 'syunik',
    nameAm: 'Սյունիք',
    nameRu: 'Сюник',
    nameEn: 'Syunik', nameFa: 'سیونیک',
    cities: [
      { id: 'syun_kapan', nameAm: 'Կապան', nameRu: 'Капан', nameEn: 'Kapan', nameFa: 'کاپان' },
      { id: 'syun_goris', nameAm: 'Գորիս', nameRu: 'Горис', nameEn: 'Goris', nameFa: 'گوریس' },
      { id: 'syun_sisian', nameAm: 'Սիսիան', nameRu: 'Сисиан', nameEn: 'Sisian', nameFa: 'سیسیان' },
      { id: 'syun_kajaran', nameAm: 'Քաջարան', nameRu: 'Каджаран', nameEn: 'Kajaran', nameFa: 'کاجاران' },
      { id: 'syun_agarak', nameAm: 'Ագարակ', nameRu: 'Агарак', nameEn: 'Agarak', nameFa: 'آگاراک' },
      { id: 'syun_meghri', nameAm: 'Մեղրի', nameRu: 'Мегри', nameEn: 'Meghri', nameFa: 'مغری' },
      { id: 'syun_dastakert', nameAm: 'Դաստակերտ', nameRu: 'Дастакерт', nameEn: 'Dastakert', nameFa: 'داستاکرت' }
    ]
  },
  {
    id: 'vayots_dzor',
    nameAm: 'Վայոց Ձոր',
    nameRu: 'Вайоц Дзор',
    nameEn: 'Vayots Dzor', nameFa: 'وایوتس جور',
    cities: [
      { id: 'vayo_yeghegnadzor', nameAm: 'Եղեգնաձոր', nameRu: 'Ехегнадзор', nameEn: 'Yeghegnadzor', nameFa: 'یغگنادزور' },
      { id: 'vayo_vayk', nameAm: 'Վայք', nameRu: 'Вайк', nameEn: 'Vayk', nameFa: 'وایک' },
      { id: 'vayo_jermuk', nameAm: 'Ջերմուկ', nameRu: 'Джермук', nameEn: 'Jermuk', nameFa: 'جرموک' }
    ]
  },
  {
    id: 'tavush',
    nameAm: 'Տավուշ',
    nameRu: 'Тавуш',
    nameEn: 'Tavush', nameFa: 'تاووش',
    cities: [
      { id: 'tavu_ijevan', nameAm: 'Իջևան', nameRu: 'Иджеван', nameEn: 'Ijevan', nameFa: 'ایجوان' },
      { id: 'tavu_dilijan', nameAm: 'Դիլիջան', nameRu: 'Дилиджан', nameEn: 'Dilijan', nameFa: 'دیلیجان' },
      { id: 'tavu_noyemberyan', nameAm: 'Նոյեմբերյան', nameRu: 'Ноемберян', nameEn: 'Noyemberyan', nameFa: 'نویمبریان' },
      { id: 'tavu_berd', nameAm: 'Բերդ', nameRu: 'Берд', nameEn: 'Berd', nameFa: 'برد' },
      { id: 'tavu_ayrum', nameAm: 'Այրում', nameRu: 'Айрум', nameEn: 'Ayrum', nameFa: 'آیروم' }
    ]
  }
];
